<template>
  <article class="@container/tile flex flex-col">
    <USkeleton class="aspect-4/3 rounded mb-4" />
    <div class="space-y-2.5 mb-5.5">
      <USkeleton class="h-5.5 @xs/tile:h-6.5 w-3/4" />
      <USkeleton class="h-3.75 w-1/3" />
    </div>
    <div class="mb-2.5">
      <USkeleton class="h-3.75 w-1/2" />
    </div>
    <slot />
  </article>
</template>
